import ApiHelper from "../../../../Helpers/ApiHelper";
import CreateQR from "../../../SharedComponents/CreateQR";
import { folderEnum } from "../../../../Helpers/EnumHelper";

export default function CoverSection({ imageName, demography, appName, qrURL }) {
  //792px X 1120px one page size
  let style = {
    height: "1123px",
    width: "792px",
    margin: 0,
    padding: 0,
  };

  let background = {
    position: "absolute",
    top: "0mm",
    left: "0mm",
    height: "1123px",
    zIndex: "-100",
    width: "792px",
    margin: "0mm",
    padding: "0mm",
  };

  return (
    <div style={style}>
      <img
        crossOrigin="anonymous"
        style={background}
        src={ApiHelper.cloudFrontURL + folderEnum.info + imageName}
        alt="Cover"
      />
      <div className="_cover-page-candidate-data-container ">
        <div className={"position-absolute"} style={{ top: "210px" }}>
          <CreateQR size={75} value={qrURL} />
        </div>

        <h1> {appName} </h1>
        <h5>
          Ad-Soyad :<span className="_cover-page-candidate-data-span">{demography?.name}</span>
        </h5>
        <h5>
          E-Posta:
          <span className="_cover-page-candidate-data-span">{demography?.email}</span>
        </h5>
        <h5>
          Doğum Yılı:
          <span className="_cover-page-candidate-data-span">{demography?.birthYear}</span>
        </h5>
        <h5>
          Cinsiyet:
          <span className="_cover-page-candidate-data-span">{demography?.gender}</span>
        </h5>
      </div>
    </div>
  );
}
